import { Injectable } from '@angular/core';
import { AccessManagementApiProvider } from '../../shared/nestjs/access-management/access-management-api';
import { RequestchangeHRDto, ResponseGetGroupAdminDto, ResponseGetListHRGoDto } from '../../shared/nestjs/gd-only/dto/access-managements.dto';
import { Subscription } from 'rxjs';
import { AppPreferences, Preference } from '../../shared/local/app-preferences.local';
import { Events } from 'ionic-angular';

/*
  Generated class for the ChangeAccessBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChangeHRBloc {

  private _subscriptions: Array<Subscription> = [];
  constructor(
    private accessManagementApiProvider: AccessManagementApiProvider,
    private appPreferences: AppPreferences,
    private events: Events
  ) {

  }

  dispose() {
    this._subscriptions.forEach(subs => subs.unsubscribe());
  }

  getGroupAdmin() {
    return new Promise<ResponseGetGroupAdminDto[]>((resolve, reject) => {
      this.accessManagementApiProvider.getGroupAdmin()
        .map((res) => res.data)
        .subscribe(result => {
          resolve(result);
        }, error => {
          reject(error);
        })
    })
  }


  listHRGo(groupName: string) {
    return new Promise<ResponseGetListHRGoDto>((resolve, reject) => {
      this.accessManagementApiProvider.listHRGo(groupName)
        .map((res) => res.data)
        .subscribe(result => {
          resolve(result);
        }, error => {
          reject(error);
        })
    })
  }

  saveChangeGDBasic(payload: RequestchangeHRDto) {
    return new Promise((resolve, reject) => {
      this._subscriptions.push(
        this.accessManagementApiProvider.changeHR(payload)
          .subscribe(async (result: any) => {
            const auth = await this.appPreferences.getAuth();
            auth.menu = result.data;
            await this.appPreferences.setGreatdayStorage(Preference.Auth, auth);
            this.events.publish('user:created', '');
            resolve(auth);
          }, error => {
            reject(error);
          })
      )
    })
  }


}



// WEBPACK FOOTER //
// ./src/bloc/settings/change-hr.bloc.ts